
import { defineComponent, onBeforeMount, reactive, ref } from "vue";
import { SysActionTypes } from "@/store/sys/action-types";
import MapBarriers from "./mapBarriers.vue";
import { barriersMap } from "@/const/barriers";
import { SysInfo } from "@/const/sys";
import { useStore } from "@/store";
import { EwgDialogRefs } from "@/types/components";
const store = useStore();

export default defineComponent({
  components: {
    MapBarriers
  },
  setup(props, ctx) {
    const position = reactive({ x: 200, y: 200 });
    const positionB = reactive({ x: 200, y: 200 });
    const currentP = reactive({ x: 200, y: 200 });
    const mapDialog = ref<EwgDialogRefs>();
    const showAll = ref(false);
    onBeforeMount(() => {
      position.x = 242;
      position.y = 446;
      currentP.x = 242;
      currentP.y = 446;
      positionB.x = 242;
      positionB.y = 446;
    });
    const mapInner = ref();
    const handleRstScale = () => {
      mapInner.value.rstScale(currentP);
    };
    const handleOpenFullMap = () => {
      showAll.value = true;
      positionB.x = position.x;
      positionB.y = position.y;
      mapDialog.value?.open();
    };
    const handleCloseFullMap = () => {
      showAll.value = false;
      setTimeout(() => {
        mapDialog.value?.close();
      }, 300);
      handleRstScale();
    };
    const changeCurrentP = ({ x, y }: { x: number; y: number }) => {
      currentP.x = x;
      currentP.y = y;
    };
    const changePosition = ({ x, y }: { x: number; y: number }) => {
      position.x = 150 - x;
      position.y = 150 - y;
    };
    const changePositionBig = ({ x, y }: { x: number; y: number }) => {
      positionB.x = 500 - x;
      positionB.y = 400 - y;
    };
    const startbattle = (id: number) => {
      ctx.emit("startbattle", id);
    };
    const handleContextmenu = (e: any) => {
      if (e.target.getAttribute("name") === "map-barriers") {
        const currentP = {
          x: e.offsetX,
          y: e.offsetY
        };
        changeCurrentP(currentP);
      } else if (e.target.getAttribute("name") === "map-barrier") {
        const currentP = {
          x: e.target.getAttribute("positionX"),
          y: e.target.getAttribute("positionY")
        };
        changeCurrentP(currentP);
        const id = +e.target.getAttribute("barrierId");
        const item = barriersMap.get(id);
        store.dispatch(
          SysActionTypes.SYS_PUSH_INFO,
          new SysInfo(`正在进入${item?.name} `, 2)
        );
        startbattle(id);
      }
    };

    return {
      position,
      positionB,
      currentP,
      mapInner,
      handleRstScale,
      handleOpenFullMap,
      handleCloseFullMap,
      changeCurrentP,
      changePosition,
      changePositionBig,
      handleContextmenu,
      mapDialog,
      showAll,
      startbattle
    };
  }
});
